(function () {
  'use strict';

  var controllers = new WeakMap();

  function debounce(callback, wait) {
    var timeout;
    return function () {
      var args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        callback.apply(null, args);
      }, wait);
    };
  }

  function close(form) {
    var results = form.querySelector('[data-predictive-search-results]');
    var input = form.querySelector('[data-predictive-search-input]');
    if (!results) return;
    results.hidden = true;
    results.innerHTML = '';
    if (input) input.setAttribute('aria-expanded', 'false');
  }

  function search(form, value) {
    var results = form.querySelector('[data-predictive-search-results]');
    var endpoint = form.dataset.predictiveSearchUrl;
    if (!results || !endpoint) return;

    var query = value.trim();
    if (query.length < 2) {
      close(form);
      return;
    }

    var previous = controllers.get(form);
    if (previous) previous.abort();
    var controller = new AbortController();
    controllers.set(form, controller);

    var params = new URLSearchParams({
      q: query,
      'resources[type]': 'product,collection,page,article',
      'resources[limit]': '8',
      'resources[options][unavailable_products]': 'hide',
      section_id: 'predictive-search'
    });

    fetch(endpoint + '?' + params.toString(), {
      signal: controller.signal,
      headers: { Accept: 'text/html' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Predictive search failed');
        return response.text();
      })
      .then(function (markup) {
        var documentFragment = new DOMParser().parseFromString(markup, 'text/html');
        var section = documentFragment.querySelector('#shopify-section-predictive-search');
        results.innerHTML = section ? section.innerHTML : markup;
        results.hidden = false;
        var input = form.querySelector('[data-predictive-search-input]');
        if (input) input.setAttribute('aria-expanded', 'true');
      })
      .catch(function (error) {
        if (error.name !== 'AbortError') close(form);
      });
  }

  function initialize(scope) {
    scope.querySelectorAll('[data-predictive-search]').forEach(function (form) {
      if (form.dataset.predictiveSearchBound === 'true') return;
      form.dataset.predictiveSearchBound = 'true';

      var input = form.querySelector('[data-predictive-search-input]');
      if (!input) return;

      input.addEventListener(
        'input',
        debounce(function () {
          search(form, input.value);
        }, 180)
      );

      input.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') close(form);
      });
    });
  }

  document.addEventListener('click', function (event) {
    document.querySelectorAll('[data-predictive-search]').forEach(function (form) {
      if (!form.contains(event.target)) close(form);
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    initialize(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
